export default "__VITE_ASSET__CLc3t87K__"